import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ORingSizeChartAs568RoutingModule } from './o-ring-size-chart-as568-routing.module';
import { ORingSizeChartAs568Component } from './o-ring-size-chart-as568.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { AGGridModule } from 'src/app/table/aggrid.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { RelatedLinksModule } from '../related-links/related-links.module';
import { ValueWithLink } from 'src/app/table/shared/value-with-link';

@NgModule({
  declarations: [ORingSizeChartAs568Component],
  imports: [
    CommonModule,
    TooltipModule.forRoot(),
    ORingSizeChartAs568RoutingModule,
    AGGridModule,
    FontAwesomeModule,
    RelatedLinksModule,
    ValueWithLink
  ]
})
export class ORingSizeChartAs568Module { }
